import React, { useEffect, useState } from "react";
import TableContainer from "../../../Component/TableContainer";
import { Box, Checkbox, IconButton, Switch, Typography } from "@mui/material";
import { useSearchParams,useNavigate } from "react-router-dom";
import { masterAPI } from "../../Masters/dataConfig";
import { axiosPrivate } from "../../../axios/axios";
import {
  ArrowBack,
  CheckCircle,
  DeleteOutline,
  DeleteOutlined,
  EditOffOutlined,
  EditOutlined,
  RadioButtonUncheckedOutlined,
} from "@mui/icons-material";
import { color } from "../../../StyleData/Config";
import ReceiptModal from "./IssueItemModal";
import { useSelector } from "react-redux";
import { decode } from "../../../Component/JWT/Formatt";
import { fromUTC } from "../../../utils/dateUtil";



import ResponsiveDialog from "../../../Component/ResponsiveDialog";
const IssueItem = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate=useNavigate()
  const actionsAllow=useSelector(state=>state.dataRed.actionsAllow)
  const issueDetail=useSelector(state=>state.dataRed.issueItem)

  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);
  const [create, setCreate] = useState(false);
  const [mode, setMode] = useState("");
  const [editData, setEditData] = useState({});
  const [filterValue, setFilterValue] = useState("enableData");
  const [backUpData, setBackUpData] = useState([]);
  const siteInfoDetail=useSelector(state=>state.auth.loginInfo)

  useEffect(() => {
    getData();
  }, []);

  const getData = async() => {
    setIsLoading(true);
    const link = masterAPI["issue"].issueList;
   await axiosPrivate
      .get(`${link}/${decode(searchParams.get("id"))}`)
      .then((res) => {
        if (filterValue === "enableData") {
          const filterDataResult = res.data.result.filter(
            (fil) => fil.isActive
          );
          console.log(filterDataResult, "filterData");
          setData(filterDataResult);
          setBackUpData(res.data.result);
        } else {
          setData(res.data.result);
          setBackUpData(res.data.result);
        }
        setIsLoading(false);
      })
      .catch((e) => {
        console.log(e, "issue Item");
        setData([])
        setBackUpData([])
        setIsLoading(false);
      });
  };

  const handleButtonNew = () => {
    setMode("Create");
    setCreate(true);
  };
  const handleCreateClose = () => {
    setMode("");
    setCreate(false);
    getData();
  };

  const handleEdit = (data) => {
    setEditData(data);
    setMode("Edit");
    setCreate(true);
  };

  // const handleDelete = (id) => {
  //   const deleteLink = masterAPI["issue"].delIssueList;
  //   axiosPrivate
  //     .delete(`${deleteLink}/${id}`)
  //     .then((res) => {
  //       console.log(res.data);
  //       getData();
  //     })
  //     .catch((e) => {
  //       console.log(e, "delete issue Item");
  //     });
  // };

  const handleDelete = async(e, id) => {
    const enableLink = masterAPI["issue"].enableItem;
    const disableLink = masterAPI["issue"].disableItem;
    if (e.target.checked) {
     await axiosPrivate
        .put(`${enableLink}/${id}`)
        .then((res) => {
          console.log(res.data);
          getData();
        })
        .catch((e) => {
          console.log(e, "enable issueItem");
        });
    } else {
     await axiosPrivate
        .put(`${disableLink}/${id}`)
        .then((res) => {
          console.log(res.data);
          getData();
        })
        .catch((e) => {
          console.log(e, "disable issueItem");
        });
    }
  };

  const columns = [
    {
      Header: "Part",
      accessor: "code",
      Cell: ({ cell }) => {
        return (
          <Typography
            sx={{
              color: "#0d6efd",
              fontSize: "inherit",
              fontWeight: 600,
              cursor: "pointer",
            }}
            // onClick={() => {
            //   handleCause(cell.row.original.id);
            // }}
          >
            {cell.value+"-"+cell.row.original.partName}
          </Typography>
        );
      },
      // disableFilters:true,
    },
  {
      Header: "Stock Name",
      accessor: "stockRoomName",
      Cell: ({ cell }) => {
        return (
          <Typography
           sx={{
            fontSize:"inherit",
            fontWeight:"inherit"
           }}
            // onClick={() => {
            //   handleCause(cell.row.original.id);
            // }}
          >
            {cell.value?cell.row.original.stockRoomCode+"-"+cell.value:"---"}
          </Typography>
        );
      },

    },
    {
      Header: "Aisle",
      accessor: "aisleName",
      Cell: ({ cell }) => {
        return (
          <Typography
           sx={{
            fontSize:"inherit",
            fontWeight:"inherit"
           }}
            // onClick={() => {
            //   handleCause(cell.row.original.id);
            // }}
          >
            {cell.value?cell.row.original.aisleCode+"-"+cell.value:"---"}
          </Typography>
        );
      },
    },
    {
      Header: "Row",
      accessor: "rowName",
      Cell: ({ cell }) => {
        return (
          <Typography
           sx={{
            fontSize:"inherit",
            fontWeight:"inherit"
           }}
            // onClick={() => {
            //   handleCause(cell.row.original.id);
            // }}
          >
            {cell.value?cell.row.original.rowCode+"-"+cell.value:"---"}
          </Typography>
        );
      },
    },
    {
      Header: "Bin",
      accessor: "binName",
      Cell: ({ cell }) => {
        return (
          <Typography
           sx={{
            fontSize:"inherit",
            fontWeight:"inherit"
           }}
            // onClick={() => {
            //   handleCause(cell.row.original.id);
            // }}
          >
            {cell.value?cell.row.original.binCode+"-"+cell.value:"---"}
          </Typography>
        );
      },
    },
    {
      Header: "Quantity",
      accessor: "quantity",
      // disableFilters:true,
    }, 
    {
      Header: "Unit Cost",
      accessor: "unitCost",
      Cell: ({cell}) =>(
        <>
        {siteInfoDetail.currencySymbol}{cell.value}
        </>
      )
    }, 
    {
      Header: "Line Cost",
      accessor: "lineCost",
      Cell: ({cell}) =>(
        <>
        {siteInfoDetail.currencySymbol}{cell.value}
        </>
      )
 
    }, 
    {
      Header: "Iussed Date",
      accessor: "issuedDate",
       Cell:({cell})=>{
              return fromUTC(cell.value).tzString;
            }

    },
    {
      Header:"Action",
      accessor:"partId",
      Cell:({cell})=>{
        return (
        //   <IconButton
        //   disabled={!actionsAllow.delete}
        //   onClick={() => {
        //     handleDelete(cell.row.original.partId);
        //   }}
        //   >
        //   <DeleteOutlined
           
        //     sx={{
        //       fontSize: color.masterEditDelButton,
        //       color:actionsAllow.delete? color.masterEditDelButtonColor:"default",
        //     }}
        //   />
        // </IconButton>
        <Switch
              disabled={
                !actionsAllow.edit 
              }
              checked={cell.row.original.isActive}
              onChange={(e) => {
                handleDelete(e, cell.row.original.id);
              }}
            />
        )
      },
      disableFilters:true,
    }
  ];

  const handleChangeFilter = (e) => {
    if (e === "showAll") {
      setData(backUpData);
    } else {
      const filterDataResult = backUpData.filter((fil) => fil.isActive);

      setData(filterDataResult);
    }
    setFilterValue(e);
  };

  return (
    <>
      <Box sx={{display:"flex",alignItems:"center"}}>
        <IconButton onClick={()=>{navigate("/inventory/issue")}}>
          <ArrowBack/>
        </IconButton>
        <Typography
          sx={{
            color: color.masterPageTitleColor,
            fontSize: color.masterPageTitleFontSize,
            fontWeight: color.masterPageTitleFontWeight,
            // mb: color.masterPageTitlemd,
          }}
        >
          {issueDetail.assetId!==null&&issueDetail.assetId!==undefined?issueDetail.assetCode+"-"+issueDetail.assetName:null}
          {issueDetail.workOrderId!==null&&issueDetail.workOrderId!==undefined?issueDetail.workOrderCode+"-"+issueDetail.workOrderName:null}
        </Typography>
      </Box>

      <TableContainer
        columns={columns}
        data={data}
        buttonNew={handleButtonNew}
        loading={isLoading}
        buttonDisable={true}
        filterValue={filterValue}
        handleChange={handleChangeFilter}
        filterShow={true}
      />

      {/* <ResponsiveDialog
        open={create}
        onClose={handleCreateClose}
        maxWidth={"xl"}
        children={
          <ReceiptModal
            handleCloseClick={handleCreateClose}
            mode={mode}
            editData={editData}
          />
        }
      /> */}
    </>
  );
};

export default IssueItem;
